import { render } from "./ApproveRejectPopUp.vue?vue&type=template&id=78137ec4&scoped=true"
import script from "./ApproveRejectPopUp.vue?vue&type=script&lang=js"
export * from "./ApproveRejectPopUp.vue?vue&type=script&lang=js"

import "./ApproveRejectPopUp.vue?vue&type=style&index=0&id=78137ec4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78137ec4"]])

export default __exports__